import React, { memo, useEffect, useMemo } from 'react';

import { Box } from '@mui/material';
import FormGenerator from '@sharedCR/common/formGenerator';
import { FormNames } from 'app/services/autoLockForms/autoLockForms.constants';

import {
  checkIsChattelCommunityPark,
  checkIsChattelLandContract,
  checkIsChattelLeasedPrivateProperty,
} from '../ChattelProperty/ChattelProperty.config';
import { defaultForm, pagesPropTypes } from '../MainContent.constants';
import { boxStyle } from '../MainContent.styles';

import { getChattelPropertyExpensesConfig } from './ChattelPropertyExpenses.config';

const ChattelPropertyExpenses = ({
  isLoading,
  isSaving,
  form = defaultForm,
  validationErrors,
  validateField,
  handleChange,
  setEntityConfig,
  setInForm,
  className,
  applicationData,
  staticValidateField,
  pendingChanges,
  disabledPendingChangesHighlight,
}) => {
  const sitePlacementValue = form.sitePlacement?.value ?? applicationData?.sitePlacement;

  const isMonthlyLotRentRequired =
    checkIsChattelLeasedPrivateProperty(sitePlacementValue) ||
    checkIsChattelCommunityPark(sitePlacementValue);

  const isLandContract = checkIsChattelLandContract(sitePlacementValue);

  const config = useMemo(
    () => getChattelPropertyExpensesConfig({ isMonthlyLotRentRequired, isLandContract }),
    [isMonthlyLotRentRequired, isLandContract],
  );

  useEffect(() => {
    setEntityConfig(config);
  }, [setEntityConfig, config]);

  return (
    <Box className={className}>
      <Box sx={boxStyle}>
        <FormGenerator
          isNestedForm
          config={config}
          disabledPendingChangesHighlight={disabledPendingChangesHighlight}
          form={form}
          formName={FormNames.CHATTEL_PROPERTY_EXPENSES}
          handleChange={handleChange}
          isLoading={isSaving || isLoading}
          numberOfColumns={4}
          pendingChanges={pendingChanges}
          setInForm={setInForm}
          staticValidateField={staticValidateField}
          validateField={validateField}
          validationErrors={validationErrors}
        />
      </Box>
    </Box>
  );
};

ChattelPropertyExpenses.propTypes = pagesPropTypes;

export default memo(ChattelPropertyExpenses);
